export default __webpack_public_path__ + "static/media/18.df31996e.png";